import * as Yup from 'yup';
import { validationSchema as addressValidationSchema } from 'components/Form/AddressFormComponent';

const validationSchema = Yup.object({
	username: Yup.string().required('pages.drivers.usernameRequired'),
	address: addressValidationSchema
});

export default validationSchema;